import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { DeviceDetectorService } from 'ngx-device-detector';
import { AuthenticationService } from '../data-services/index';
import { IUser, IHelp, IContact } from '@ebb-v2/ebb-integration';
import { DomSanitizer } from '@angular/platform-browser';

// import { GuidedTour, Orientation } from 'ngx-guided-tour';
// import { GuidedTourService } from 'ngx-guided-tour';
import { BehaviorSubject, fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { MatRipple, RippleRef } from '@angular/material/core';

@Component({
    selector: 'ebb-traning-app-page',
    templateUrl: './app-page.component.html',
    styles: [],
    standalone: false
})
export class AppPageComponent implements OnInit {
  @ViewChild(MatRipple) ripple: MatRipple;

  public currentUser: IUser = null;
  public currentUserName = '';
  public currentUserType = '';
  public contact: IContact = null;
  public isloaded: boolean;
  public trainingType: string='';

  constructor(
    private readonly authenticationService: AuthenticationService,
    public readonly sanitizer: DomSanitizer
  ) 
  {

  }

    async ngOnInit() {
    
      const programMapping = {
        ESS: '700000001',
        EMR: '700000002',
      };
      
      this.trainingType = programMapping[window['program']] || '700000000';
      
      
      
        
        this.currentUser = this.authenticationService.currentUserValue;
        this.isloaded =true;
              
       
   
    
   
    
   
  }

  private loadCurrentUserName(name: string): void {
    if (name && name.length > 0) {
      this.currentUserName = name;
    } else {
      if (this.authenticationService.currentUserValue) {
        this.currentUserName = this.authenticationService.currentUserValue.fullName;
      }
    }
  }

  public isContractor() {
    return this.authenticationService.isContractor(this.currentUser);
  }
}
